'use es6';

import * as ActionTypes from 'crm_data/actions/ActionTypes';
import { dispatch } from 'crm_data/flux/dispatch';
export const authLoaded = auth => dispatch(ActionTypes.AUTH_LOADED, auth);